import { render, staticRenderFns } from "./TableLink.vue?vue&type=template&id=ca6340f0&"
import script from "./TableLink.vue?vue&type=script&lang=js&"
export * from "./TableLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports